import React from 'react';
import { useCalendarNavigation } from '../context/CalendarNavigationContext';

const CalendarNavigation = ({
  showTodayButton = true,
  prevLabel = '‹',
  nextLabel = '›',
  todayLabel = 'Dziś',
  className = '',
}) => {
  const {
    weekLabel,
    isThisWeek,
    goToPrevWeek,
    goToNextWeek,
    goToToday,
  } = useCalendarNavigation();

  return (
    <div className={`calendar-navigation ${className}`}>
      <button
        type="button"
        className="calendar-navigation__prev"
        onClick={goToPrevWeek}
        aria-label="Poprzedni tydzień"
      >
        {prevLabel}
      </button>

      <div className="calendar-navigation__current">
        {weekLabel}
      </div>

      <button
        type="button"
        className="calendar-navigation__next"
        onClick={goToNextWeek}
        aria-label="Następny tydzień"
      >
        {nextLabel}
      </button>
    </div>
  );
};

export default CalendarNavigation;
